import * as THREE from 'three';

/**
 * Cap (shell mesh) and Body (array instances) each own a GlbModel. Without sharing,
 * they keep separate MeshPhysicalMaterials for the same library graph — Cap can finish
 * its tint apply a beat before Body, which reads as Cap-first on clearcoat (carpaint).
 * Objects that receive the same `__c3dShareKey` share one live material.
 */
const sharedByKey = new Map<string, THREE.MeshPhysicalMaterial>();

export function getSharedGraphMaterial(
  shareKey: string,
  create: () => THREE.MeshPhysicalMaterial,
): THREE.MeshPhysicalMaterial {
  let mat = sharedByKey.get(shareKey);
  if (!mat) {
    mat = create();
    sharedByKey.set(shareKey, mat);
  }
  return mat;
}

export function peekSharedGraphMaterial(shareKey: string): THREE.MeshPhysicalMaterial | undefined {
  return sharedByKey.get(shareKey);
}

/** Drop a shared slot so the next get recreates (e.g. transmission program flip). */
export function invalidateSharedGraphMaterial(shareKey: string): void {
  sharedByKey.delete(shareKey);
}
